import React from "react"
import cn from "classnames"

interface Props {
  className?: string
  errors: string | string[] | object[];
}

const SubmitError = (props: Props): JSX.Element | null => {
  if (!props.errors) return null;
  const className = cn("Typography--bittersweet first-letter-uppercase", props.className);
  let errors = null;
  if(Array.isArray(props.errors)) {
    errors = props.errors.map((error, index) => {
      if(typeof error === "string") return <span className="block" key={index}>{error}</span>
    });
  } else {
    errors = props.errors;
  }

  return <div className={className}>{errors}</div>
};

export default SubmitError;
